module.exports = __webpack_public_path__ + "files/00446aef729e79808976269ff383a21d.png";